<template>
  <user-delegation-permissions-data-form></user-delegation-permissions-data-form>
</template>

<script>
import UserDelegationPermissionsDataForm from "../../../../components/Settings/Users/UserDelegationPermissionsDataForm";
export default {
  name: "SettingsUserEditRolesAndPermissionsView",
  components: { UserDelegationPermissionsDataForm }
};
</script>

<style scoped></style>
